// common/services/geo/listProvinces.ts
//
// GET /countries/:id/provinces — the provinces/states for a country.
// Geo data, so it's cached aggressively by the React Query hook that wraps it
// (see common/hooks/useProvinces.ts). The endpoint returns the array at the top
// level (not under a `data` key), so we return the response verbatim.

import req from '../../api/request'

export type Province = {
  id: number
  country_id: number
  name: string
  iso_3166_2: string
  geonames_id: number
  geonames_code: string
}

export const listProvinces = async (
  countryId: string | number
): Promise<Province[]> => {
  const response = await req(`/countries/${countryId}/provinces`)
  return Array.isArray(response) ? (response as Province[]) : []
}
